<template>
	<Layout>
		<!-- 최상단 배너 -->
		<div class="top">
			<div class="top__wrap">
				<h1>
					더조인은<br />
					긍정적인 영향을 주는<br />
					서비스와 기술을<br class="mbr" />
					개발합니다.
				</h1>
				<p class="top__wrap__nav">
					<button @click="$router.push('/')">
						홈
					</button>
					<i class="icon-right"></i>
					<span class="active">회사소개</span>
				</p>
			</div>
			<div class="top__bg left"></div>
			<div class="top__bg right"></div>
		</div>
		<!-- 헬스앤유,jvmp 라우트 버튼영역 -->
		<div class="route-area">
			<div class="inner-wrap">
				<h2>
					디지털 시대 사람들의<br />
					<span>스마트하고 편리한 일상</span>을
					지원합니다.
				</h2>

				<div class="route-area__btns">
					<div
						class="route-area__btns__button"
						v-for="btn in buttons"
						:key="btn.i"
						@click="$router.push(btn.route)"
					>
						<div class="logo-area">
							<div class="logo-area__left">
								<img
									:src="btn.gnbPath"
									alt="gnb"
									loading="lazy"
								/>
								<div
									class="logo-area__left__title"
								>
									<p>{{ btn.title1 }}</p>
									<h3>{{ btn.title2 }}</h3>
								</div>
							</div>
							<div class="roundBtn">
								<i
									class="icon-arrow_right_top"
								></i>
							</div>
						</div>
						<p
							class="subtitle"
							v-html="btn.subtitle"
						></p>
						<div
							class="route-area__btns__button__img"
						>
							<img
								:src="btn.bgPath"
								alt="이미지"
								loading="lazy"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 소식 -->
		<div class="news">
			<div class="inner-wrap">
				<h3>
					더조인의 주요 소식을 확인해 보세요.
				</h3>
				<div class="news__wrap">
					<div
						v-for="item in news"
						:key="item.i"
						class="news__wrap__card"
						@click="$utils.newsClick(item.newsSn)"
					>
						<div class="img-wrap">
							<img
								:src="resolveUrl(item.image)"
								alt="뉴스이미지"
								loading="lazy"
							/>
						</div>
						<div>
							<h4>{{ item.title }}</h4>
							<b>{{ item.boardClf }}</b>
							<span>{{ item.date }}</span>
						</div>
					</div>
				</div>
				<CustomBtn
					class="news__wrap__btn"
					:isDark="false"
					:text="'소식 전체보기'"
					@onClick="$router.push('/news')"
				></CustomBtn>
			</div>
		</div>
		<!-- 연혁 -->
		<div class="history">
			<div class="inner-wrap">
				<div class="history-wrap">
					<div class="history-wrap__title">
						<h2>우리가 걸어온 길</h2>
						<button
							v-for="item in historyClfArr"
							:key="item.i"
							@click="activeHistory = item"
							:class="
								activeHistory == item
									? 'active'
									: null
							"
						>
							{{ item }}
						</button>
					</div>
					<div class="history-wrap__btn">
						<button
							class="roundBtn"
							:class="
								historySwiper &&
								historySwiper.isBeginning
									? 'gray'
									: 'black'
							"
							@click="
								historySwiper.isBeginning
									? null
									: historySwiper.slidePrev()
							"
						>
							<i class="icon-arrow_left"></i>
						</button>
						<button
							class="roundBtn"
							:class="
								historySwiper &&
								historySwiper.isEnd
									? 'gray'
									: 'black'
							"
							@click="
								historySwiper.isEnd
									? null
									: historySwiper.slideNext()
							"
						>
							<i class="icon-arrow_right"></i>
						</button>
					</div>
					<div class="history-wrap__slide">
						<Swiper
							v-bind="swiperOptions"
							class="history-swiper"
							@swiper="
								(swiper) => {
									historySwiper = swiper;
								}
							"
							id="historySwiper"
						>
							<SwiperSlide
								class="history-swiper__slide"
								v-for="item in historyJson"
								:key="item.i"
								><div>
									<div class="year">
										{{ item.year }}
									</div>
									<ul>
										<li
											v-for="list in item.list"
											:key="list.i"
											:class="
												list.historyClf ==
													activeHistory ||
												activeHistory == '전체'
													? 'active'
													: null
											"
										>
											{{ list.title }}
										</li>
									</ul>
								</div></SwiperSlide
							></Swiper
						>
					</div>
				</div>
			</div>
		</div>
		<!-- 더조인 공식 파트너 -->
		<div class="partner">
			<div class="partner__wrap">
				<div class="partner__wrap__title">
					<h2>
						더조인<br class="pbr" />공식 파트너
					</h2>
					<small
						>더조인과 함께하면<br />비즈니스가
						즐거워집니다.</small
					>
				</div>
				<div class="partner__wrap__scroll">
					<div
						class="content"
						v-for="grp in partnerGrp"
						:key="grp.i"
					>
						<h4>{{ grp.title }}</h4>
						<Swiper
							class="content__wrap"
							v-bind="{
								spaceBetween: 16,
								breakpoints: {
									0: {
										slidesPerView: 1.2,
									},
									768: {
										slidesPerView: 2.2,
									},
									1100: {
										slidesPerView: 2.2,
									},
								},
							}"
						>
							<SwiperSlide
								v-for="list in grp.list"
								:key="list.i"
								class="grp"
							>
								<img
									:src="list.icon"
									alt="group gnb"
									loading="lazy"
								/>
								<div class="grp__text">
									<b>{{ list.name }}</b>
									<p>{{ list.text }}</p>
								</div>
							</SwiperSlide>
						</Swiper>
					</div>
				</div>
			</div>
		</div>
		<!-- 주소 -->
		<div class="map">
			<h2>
				더조인과 함께<br class="pbr" />
				<br class="tbr" />
				즐거운
				<br class="mbr" />
				비즈니스를 시작해 보세요.
			</h2>
			<div class="map__wrap">
				<div
					class="map__wrap__img"
					id="map"
					@click="mapClick()"
				></div>
				<div class="map__wrap__adress">
					<h4>(주)더조인</h4>
					<div class="map__wrap__adress__text">
						<b>주소</b>
						<span
							>서울시 강남구 봉은사로30길 63,
							3층(역삼동, 영신빌딩)</span
						>
						<b>오시는 길</b>
						<span
							>2호선 역삼역 7번 출구 도보
							319m</span
						>
						<b>대표전화</b>
						<span> 02-6949-0335</span>
						<b>이메일</b>
						<span> thejoin@thejoin.co.kr</span>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import {
	onBeforeMount,
	onBeforeUnmount,
	onMounted,
	onRenderTracked,
	onUnmounted,
	Ref,
	ref,
} from 'vue';
import json from '../json/news3.json';
import newsJson from '../json/news.json';
import historyJson from '../json/history.json';
import log from '@/global/log';
import { getHashTime } from '@/global/utils';
import router from '@/router';
// // import { Swiper, SwiperSlide } from 'swiper/vue';
//  import { Pagination, Navigation, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
export default {
	components: {
		Swiper,
		SwiperSlide,
	},
	setup() {
		let news = ref([]);
		let activeHistory = ref('전체');
		let historySwiper = ref(null);

		function mapClick() {
			window.open(
				'https://map.kakao.com/link/map/726480354',
				'_blank'
			);
		}

		function drawMap(zoomLv) {
			const container =
				document.getElementById('map');
			var options = {
				center: new kakao.maps.LatLng(
					37.5020771,
					127.03678
				),
				level: zoomLv,
				marker: {
					position: new kakao.maps.LatLng(
						37.5034826,
						127.036883
					),
				},
			};

			if (container) {
				var map = new kakao.maps.StaticMap(
					container,
					options
				);
				// map.setZoomable(false);
				// map.setDraggable(false);

				// // 마커가 표시될 위치입니다
				// var markerPosition =
				// 	new kakao.maps.LatLng(
				// 		37.5034826,
				// 		127.036883
				// 	);

				// // 마커를 생성합니다
				// var marker = new kakao.maps.Marker({
				// 	position: markerPosition,
				// });
				// // 마커가 지도 위에 표시되도록 설정합니다
				// marker.setMap(map);

				// var content =
				// 	'<a style="width:97px;height:55px;display: block;transform: translate(0,-50%)" href="https://map.kakao.com/link/map/726480354" target="_blank"><img    id="map_tooltip" style="width: 100%; height: 100%;"/></a>';

				// // 커스텀 오버레이가 표시될 위치입니다
				// var position = new kakao.maps.LatLng(
				// 	37.5034826,
				// 	127.036883
				// );

				// // 커스텀 오버레이를 생성합니다
				// var customOverlay =
				// 	new kakao.maps.CustomOverlay({
				// 		position: position,
				// 		content: content,
				// 	});

				// // 커스텀 오버레이를 지도에 표시합니다
				// customOverlay.setMap(map);

				// const imgUrl = new URL(
				// 	'@/assets/images/about/map_tooltip.png',
				// 	import.meta.url
				// ).href;

				// log('url', imgUrl);

				// document.getElementById(
				// 	'map_tooltip'
				// ).src = imgUrl;
			}
		}



		function resolveUrl(path) {
			let images = require.context(
				'@/assets/images/news/',
				false,
				/\.(png|jpg|webp)$/
			);
			return images('./' + path);
		}

		function reDraw() {
			const tooltipEl = document.getElementById(
				'map_tooltip'
			);
			if (tooltipEl) {
				tooltipEl.remove();
			}
			const screenWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			if (screenWidth < 768) {
				drawMap(5);
			} else if (screenWidth < 1280) {
				drawMap(4);
			} else {
				drawMap(3);
			}
		}
		onBeforeMount(() => {
			log('onBeforeMount');

			news.value = json;
		}),
			onMounted(() => {
				log('onMounted');
				reDraw();

				window.addEventListener('resize', () => {
					reDraw();
				});
			});
		onUnmounted(() => {
			log('onUnmounted');
		});
		onBeforeUnmount(() => {
			log('onBeforeUnmount');
			window.removeEventListener('resize', () => {
				reDraw();
			});
		});

		onRenderTracked(() => {
			log('onRenderTracked');
		});

		return {
			resolveUrl,
			buttons: [
				{
					gnbPath: require('../assets/images/about/hnu_gnb.png'),
					title1: '디지털 헬스케어 플랫폼',
					title2: 'Health&u',
					route: '/health',
					subtitle:
						'사람과 서비스를 연결하여<br> 더 많은 사람들을 건강하게 만듭니다.',
					bgPath: require('../assets/images/about/hnu_bg.png'),
				},
				{
					gnbPath: require('../assets/images/about/jvmp_gnb.png'),
					title1: '모바일 가상화 솔루션',
					title2: 'J-VMP',
					route: '/jvmp',
					subtitle:
						'안전한 모바일 가상공간을 제공하여 기업의<br>업무방식을 혁신적으로 변화시킵니다.',
					bgPath: require('../assets/images/about/jvmp_bg.png'),
				},
			],
			news,
			activeHistory,
			historySwiper,
			historyClfArr: [
				'전체',
				'더조인',
				'헬스케어 플랫폼',
				'모바일 가상화 플랫폼',
			],
			historyJson,
			swiperOptions: {
				breakpoints: {
					0: {
						slidesPerView: 1,
					},
					768: {
						slidesPerView: 2,
					},
					1100: {
						slidesPerView: 3,
					},
				},
			},
			partnerGrp: [
				{
					title: '헬스케어 플랫폼',
					list: [
						{
							icon: require('@/assets/images/about/gnb_seven.png'),
							name: '세븐일렉',
							text: '스마트기기 제조 전문회사로써 공공분야 스마트워치 점유율 1위 업체입니다. 더조인의 모바일 헬스케어 앱과 연동되는 스마트기기를 공급하고 있습니다.',
						},
						{
							icon: require('@/assets/images/about/gnb_pt.png'),
							name: '한국신체정보',
							text: '모션 인식 세계 1등 기술을 보유한 AI기반 건강 관리 업체로 더조인의 모바일 헬스케어 앱 내에 모션인식 기술을 활용한 자세, 체력 검사 후 추천운동 서비스를 제공하고 있습니다.',
						},
						{
							icon: require('@/assets/images/about/gnb_doing.png'),
							name: '두잉랩',
							text: '음식 인식 및 영양소 측정기술의 선두 기업으로 더조인의 모바일 헬스케어 앱 내에 인공지능 기술을 사용한 음식 이미지 자동인식 및 분석, 섭취음식 평가정보 서비스 제공하고 있습니다.',
						},
					],
				},
				{
					title: '모바일 가상화 솔루션',
					list: [
						{
							icon: require('@/assets/images/about/gnb_sk.png'),
							name: 'SK 쉴더스',
							text: '보안 및 안전 관리 전문기업으로 모바일 보안 전략 파트너로 함께하고 있습니다.',
						},
						{
							icon: require('@/assets/images/about/gnb_may.png'),
							name: '메이머스트',
							text: '행정안전부의 전자정부 모바일 공통기반 구축과 운영을 하고 있으며 J-VMP 솔루션 총판 계약을 체결하여 공공기관 신규고객 발굴 및 공동 마케팅을 진행하고 있습니다.',
						},
						{
							icon: require('@/assets/images/about/gnb_sna.png'),
							name: 'SNA',
							text: '하드웨어 인프라 구축, 통합 유지보수, 솔루션 유통 등 원스톱 IT 서비스 제공하며 모바일 가상화 솔루션 J-VMP 총판을 통해 기존 고객 대상 신규 모바일 보안 및 클라우드 비즈니스를 진행하고 있습니다.',
						},
					],
				},
			],
			mapClick,
		};
	},
};
</script>
<style lang="scss" scoped>
.top {
	width: 100%;
	height: 850px;
	position: relative;
	overflow: hidden;
	background: linear-gradient(
		104deg,
		#31a9cf 18.28%,
		#3170cf 50.5%,
		#0c49a5 87.78%
	);
	&__wrap {
		position: absolute;
		top: 0;
		left: 50%;
		z-index: 1;
		transform: translate(-50%, 0);
		text-align: left;
		width: calc($tabletW + 1px);
		h1 {
			margin: 190px 0 216px;
			@include D1($gray0);
			text-align: left;
		}
		&__nav {
			display: inline-flex;
			align-items: center;
			button,
			span {
				@include BodyLB($gray0);
				opacity: 0.4;

				&.active {
					opacity: 1;
				}
			}
			i {
				padding: 0 4px;
				color: $gray0;
				font-size: 24px;
				opacity: 0.4;
			}
		}
	}
	&__bg {
		position: absolute;
		z-index: 0;
		&.left {
			left: -100px;
			top: -40px;
			width: 747px;
			height: 747px;
			transform: rotate(83.795deg);
			aspect-ratio: 1/1;
			border-radius: 50%;
			background: linear-gradient(
				68deg,
				rgba(15, 218, 239, 0.2) 38.57%,
				rgba(255, 255, 255, 0) 72.04%
			);
		}
		&.right {
			left: 75%;
			bottom: -470px;
			width: 1303px;
			height: 1236px;
			background-size: 100% auto;
			background-position: center;
			background-repeat: no-repeat;
			background-image: url('../assets/images/about/bg.png');
			transform: translate(-50%, 0);
		}
	}
}
.inner-wrap {
	width: calc($tabletW + 1px);
	margin: 0 auto;
}
.route-area {
	padding: 160px 0 180px;
	background: $bgD;
	h2 {
		@include D3($gray0);
		span {
			color: $brandD1;
		}
		margin-bottom: 80px;
	}
	&__btns {
		display: flex;
		justify-content: space-between;
		&__button {
			cursor: pointer;
			background: $gradient;
			border-radius: 20px;
			padding: 50px;
			position: relative;
			width: calc(50% - 8px);
			overflow: hidden;
			transition: all 0.3s;

			&:active,
			&:hover {
				transform: translate(0, -20px);
			}
			&:last-child {
				background: linear-gradient(
					315deg,
					#89aaff -20.28%,
					#6851f3 35.58%,
					#7753df 90.28%
				);
			}
			.logo-area {
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				margin-bottom: 30px;
				&__left {
					flex: 1;
					display: flex;
					img {
						width: 80px;
						height: 80px;
						margin-right: 20px;
					}
					&__title {
						p {
							@include BodyM($gray0);
						}
						h3 {
							@include D3($gray0);
						}
					}
				}
			}
			.subtitle {
				@include BodyL($gray0);
				margin-bottom: 364px;
			}
			&__img {
				bottom: 0;
				right: 0;
				position: absolute;
				width: 480px;
				height: 364px;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
	}
}
.news {
	padding: 177px 0 80px;
	background: linear-gradient(
		180deg,
		$gray0 72%,
		$bgL 72%
	);
	h3 {
		@include D3($gray8);
		margin-bottom: 60px;
		text-align: center;
	}
	&__wrap {
		display: flex;
		justify-content: space-between;
		margin-bottom: 43px;
		align-items: flex-start;
		&__card {
			width: 32.5%;
			border-radius: 20px;
			box-shadow: $cardShadowOff;
			transition: all 0.5s;
			background: $gray0;
			overflow: hidden;
			padding-bottom: 20px;
			cursor: pointer;
			.img-wrap {
				height: 304px;
				width: 100%;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			h4 {
				@include BodyLB($gray7);
				margin: 20px 16px 8px;
				height: 56px;
				@include textEllipsis();
			}
			b {
				@include BodySB($brandD1);
				margin: 0 12px 0 16px;
			}
			span {
				@include BodyS($gray5);
			}

			&:nth-child(2n-1) {
				margin-top: 80px;
			}
			&:hover,
			&:active {
				box-shadow: $cardShadowOn;
				transform: translate(0, -20px);
			}
		}
		&__btn {
			margin: 0 auto;
		}
	}
}
.history {
	padding: 160px 0 120px;
	background: $bgL;

	.history-wrap {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		width: 100%;
		&__title {
			margin-bottom: 72px;
			h2 {
				@include D2($gray8);
			}
			button {
				padding: 18px 14px 0 0;
				@include BodyLB($gray6);
				transition: all 0.3s;
				opacity: 0.4;
				&.active {
					opacity: 1;
				}
			}
		}
		&__btn {
			display: flex;
			justify-content: flex-end;
			button {
				&:first-of-type {
					margin-right: 16px;
				}
			}
		}
		&__slide {
			width: 100%;
			height: auto;

			// 스와이퍼
			.history-swiper {
				height: 100%;
				&__slide {
					border-top: 1px solid $gray2;
					display: block;
					width: 100%;
					position: relative;
					margin-top: 6px;
					&::after {
						position: absolute;
						content: '';
						width: 12px;
						height: 12px;
						top: -6px;
						left: 0;
						border-radius: 50%;
						background: $gray5;
					}
					.year {
						@include Dsub($brandL1);
						margin: 30px 0 34px;
					}
					ul {
						height: 240px;
						margin-right: 100px;
						overflow: hidden;
						// 글자 드래그 방지
						-webkit-user-select: none; /* Safari 및 이전 버전의 Chrome, Edge */
						-moz-user-select: none; /* Firefox */
						-ms-user-select: none; /* Internet Explorer 및 Edge 15 이상 */
						user-select: none; /* 일반적인 사용 */
						li {
							opacity: 0.4;
							@include BodyM($gray6);
							transition: all 0.3s;
							margin-bottom: 10px;
							&.active {
								opacity: 1;
							}
						}
					}
				}
			}
		}
	}
}
.partner {
	&__wrap {
		width: calc(
			((100% - ($tabletW + 1px)) / 2) +
				($tabletW + 1px)
		);
		margin: 120px 0 240px auto;
		display: flex;
		overflow: hidden;
		&__title {
			min-width: 300px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			h2 {
				@include D2();
			}
			small {
				@include BodyL($gray5);
				margin-bottom: 14px;
			}
		}
		&__scroll {
			width: calc(100% - 300px);
			.content {
				width: 100%;
				position: relative;
				h4 {
					@include BodyLB($gray6);
					padding-left: 32px;
				}
				&:after {
					position: absolute;
					left: 0;
					top: 0;
					content: '';
					width: 32px;
					height: 100%;
					background: linear-gradient(
						90deg,
						white,
						transparent
					);
				}
				&__wrap {
					width: 100%;
					display: flex;
					padding: 14px 32px;

					&::-webkit-scrollbar-thumb {
						background: transparent;
					}

					.grp {
						display: inline-flex;
						padding: 20px;
						width: 524px;
						box-shadow: $cardShadowOff;
						border-radius: 14px;
						height: auto;

						img {
							width: 134px;
							height: 134px;
							margin-right: 26px;
						}
						&__text {
							display: flex;
							align-items: center;
							flex-direction: column;
							justify-content: center;
							flex: 1;
							overflow: hidden;
							b {
								@include BodyLB();
								margin-bottom: 4px;
								width: 100%;
								text-align: left;
							}
							p {
								@include BodyM($gray6);
								width: 100%;
								white-space: initial;
							}
						}
					}
				}
				&:first-of-type {
					margin-bottom: 22px;
				}
			}
		}
	}
}
.map {
	text-align: center;
	h2 {
		@include D2();
		margin-bottom: 60px;
	}
	&__wrap {
		width: 100%;
		max-width: 1377px;
		height: 696px;
		border-radius: 20px;
		margin: 0 auto 335px;
		position: relative;
		background: $gray0;
		&__img {
			width: 100%;
			height: 100%;
			border-radius: 20px;
		}
		&__adress {
			position: absolute;
			z-index: 20;
			width: 1160px;
			background: $gray0;
			left: 50%;
			bottom: -100px;
			transform: translate(-50%, 0);
			display: flex;
			padding: 28px 40px;
			border-radius: 20px;
			box-shadow: $cardShadowOff;
			h4 {
				@include Dsub();
			}
			&__text {
				margin-left: 150px;
				flex: 1;
				display: flex;
				flex-wrap: wrap;
				text-align: left;
				b {
					width: 110px;
					margin: 8px 0;
					@include BodyLB();
				}
				span {
					width: 700px;
					margin: 8px 0;
					@include BodyM($gray6);
					word-break: break-all;
				}
			}
		}
	}
}
// 태블릿
@media screen and (max-width: $tabletW) {
	.top {
		height: 680px;
		&__wrap {
			width: 100%;
			padding: 0 40px;
			h1 {
				margin: 48px 0 428px;
				@include T1($gray0);
			}
			&__nav {
				display: none;
			}
		}
		&__bg {
			&.left {
				left: -250px;
				top: -50px;
				width: 597px;
				height: 597px;
			}
			&.right {
				left: 75%;
				bottom: -250px;
				width: 734px;
				height: 696px;
			}
		}
	}
	.inner-wrap {
		width: calc($mobileW + 1px);
		padding: 0 24px;
		width: 100%;
	}
	.route-area {
		padding: 60px 0;
		h2 {
			@include T3($gray0);
			margin-bottom: 40px;
			text-align: center;
		}
		&__btns {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			&__button {
				width: 632px;
				overflow: hidden;
				transition: all 0.3s;
				&:last-child {
					margin-top: 20px;
				}
				.logo-area {
					margin-bottom: 24px;
					&__left {
						img {
							width: 62px;
							height: 62px;
							margin-right: 20px;
						}
						&__title {
							p {
								@include BodyS($gray0);
							}
							h3 {
								@include T3($gray0);
							}
						}
					}
				}
				.subtitle {
					@include BodyM($gray0);
					margin-bottom: 286px;
				}
				&__img {
				}
			}
		}
	}
	.news {
		padding: 160px 0 80px;
		background: $gray0;
		h3 {
			@include T3($gray8);
			margin-bottom: 40px;
		}
		&__wrap {
			width: 520px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			margin-bottom: 40px;
			&__card {
				width: 100%;
				margin-bottom: 20px;
				display: flex;
				padding-bottom: 0;
				cursor: pointer;
				.img-wrap {
					height: 104px;
					width: 104px;
					min-width: 104px;
				}

				h4 {
					@include BodyMB($gray7);
					margin: 14px 16px 6px;
					height: 50px;
				}
				b {
					margin: 0 12px 0 16px;
				}

				&:nth-child(2n-1) {
					margin-top: 0;
				}
			}
			&__btn {
				margin: 0 auto;
			}
		}
	}
	.history {
		padding: 120px 0 80px;

		.history-wrap {
			display: flex;
			width: 100%;
			&__title {
				width: 100%;
				margin-bottom: 72px;
				text-align: center;
				h2 {
					@include T2($gray8);
					text-align: center;
					margin-bottom: 19px;
				}
				button {
					padding: 7px;
				}
			}
			&__btn {
				order: 1;
				width: 100%;
				justify-content: center;
				margin-top: 10px;
				button {
					&:first-of-type {
						margin-right: 10px;
					}
				}
			}
			&__slide {
				// 스와이퍼
				.history-swiper {
					height: 100%;
					&__slide {
						.year {
							@include T4($brandL1);
						}
						ul {
							height: 340px;
							margin-right: 80px;
							overflow-y: hidden;
						}
					}
				}
			}
		}
	}
	.partner {
		&__wrap {
			width: 100%;
			margin: 120px 0 160px;
			flex-direction: column;
			&__title {
				min-width: 100%;
				h2 {
					@include T2();
					margin-bottom: 40px;
					text-align: center;
				}
				small {
					display: none;
				}
			}
			&__scroll {
				width: 100%;
				.content {
					h4 {
						padding-left: 32px;
					}
					&:after {
						position: absolute;
						left: 0;
						top: 0;
						content: '';
						width: 32px;
						height: 100%;
						background: linear-gradient(
							90deg,
							white,
							transparent
						);
					}
					&__wrap {
						width: 100%;
						padding: 20px 32px;
						// display: flex;
						// justify-content: space-between;
						.grp {
							display: inline-flex;
							flex-direction: column;
							width: 372px;
							height: 280px;
							img {
								width: 100px;
								height: 100px;
								margin: 0 0 12px 0;
							}
							&__text {
								display: flex;
								align-items: center;
								flex-direction: column;
								justify-content: flex-start;
								b {
									text-align: left;
								}
							}
						}
					}
					&:first-of-type {
						margin-bottom: 58px;
					}
				}
			}
		}
	}

	.map {
		padding: 0 24px;
		h2 {
			@include T2();
			margin-bottom: 40px;
		}
		&__wrap {
			height: 460px;
			margin: 0 auto 285px;
			&__adress {
				position: absolute;
				z-index: 20;
				width: 80%;
				bottom: -185px;
				flex-direction: column;
				align-items: flex-start;
				padding: 30px 40px;
				h4 {
					@include T4();
					margin-bottom: 19px;
				}
				&__text {
					margin-left: 0;
					flex: 1;
					display: flex;
					flex-wrap: wrap;
					text-align: left;
					b {
						width: 110px;
						margin: 5px 0;
						@include BodyMB();
					}
					span {
						width: calc(100% - 110px);
						margin: 5px 0;
						@include BodyM($gray6);
					}
				}
			}
		}
	}
}
// 모바일
@media screen and (max-width: $mobileW) {
	.top {
		height: 531px;
		&__wrap {
			padding: 0 20px;
			h1 {
				margin: 40px 0 323px;
				@include M1($gray0);
			}
		}
		&__bg {
			&.left {
				left: -330px;
				top: -20px;
				width: 466px;
				height: 466px;
			}
			&.right {
				left: 70%;
				bottom: -70px;
				width: 405px;
				height: 384px;
			}
		}
	}
	.inner-wrap {
		width: 100%;
	}
	.route-area {
		padding: 80px 0 60px;
		h2 {
			@include M3($gray0);
			margin-bottom: 30px;
		}
		&__btns {
			&__button {
				padding: 24px;
				width: 100%;
				&:last-child {
					margin-top: 12px;
				}
				.logo-area {
					margin-bottom: 20px;
					&__left {
						img {
							width: 50px;
							height: 50px;
							margin-right: 14px;
						}
						&__title {
							h3 {
								@include M3($gray0);
							}
						}
					}
					&__route {
						display: none;
					}
				}
				.subtitle {
					@include BodyS($gray0);
					margin-bottom: 150px;
				}
				&__img {
					width: 201px;
					height: 150px;
				}
			}
		}
	}
	.news {
		padding: 120px 0;

		h3 {
			@include M3($gray8);
			margin-bottom: 30px;
		}
		&__wrap {
			width: 100%;
			&__card {
				border-radius: 14px;
				h4 {
					height: 50px;
				}
			}
		}
	}
	.history {
		padding: 50px 0;

		.history-wrap {
			&__title {
				margin-bottom: 40px;
				h2 {
					@include M2($gray8);
					margin-bottom: 14px;
				}
				button {
					padding: 0 6px;
					@include BodySB($gray6);
				}
			}
			&__btn {
				button {
					&:first-of-type {
						margin-right: 8px;
					}
				}
			}
			&__slide {
				// 스와이퍼
				.history-swiper {
					&__slide {
						.year {
							@include M4($brandL1);
						}
						ul {
							li {
								@include BodyS($gray6);
							}
							height: 210px;
							margin-right: 0;
							overflow-y: hidden;
						}
					}
				}
			}
		}
	}
	.partner {
		&__wrap {
			width: 100%;
			margin: 120px 0 110px;
			&__title {
				h2 {
					@include M2();
					margin-bottom: 30px;
				}
			}
			&__scroll {
				width: 100%;
				.content {
					h4 {
						padding-left: 26px;
					}
					&:after {
						position: absolute;
						left: 0;
						top: 0;
						content: '';
						width: 26px;
						height: 100%;
						background: linear-gradient(
							90deg,
							white,
							transparent
						);
					}
					&__wrap {
						width: 100%;
						padding: 20px 26px;
						overflow-y: scroll;
						display: block;
						white-space: nowrap;
						.grp {
							flex-direction: column;
							height: auto;
							padding: 20px 20px 30px;
							img {
								width: 60px;
								height: 60px;
								margin: 0 0 12px 0;
							}
							&__text {
								display: flex;
								align-items: center;
								flex-direction: column;
								justify-content: flex-start;
								b {
									@include BodyMB();
									margin-bottom: 4px;
								}
								p {
									@include BodyS($gray6);
								}
							}
						}
					}
					&:first-of-type {
						margin-bottom: 58px;
					}
				}
			}
		}
	}
	.map {
		padding: 0 20px;
		h2 {
			@include M2();
			margin-bottom: 30px;
		}
		&__wrap {
			height: 250px;
			margin: 0 auto 240px;
			&__adress {
				position: absolute;
				z-index: 20;
				width: 90%;
				bottom: -177px;
				padding: 20px;
				h4 {
					@include M4();
				}
				&__text {
					b {
						width: 70px;
						@include BodySB();
					}
					span {
						width: calc(100% - 70px);
						@include BodyS($gray6);
					}
				}
			}
		}
	}
}
</style>
